import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import Cfop from "./Cfop";
import Configuration from "./Configuration";
import Data from "./Data";
import { getBloqueioCfopConfiguracao } from "./actions"

const TabPane = Tabs.TabPane;

const DataCompany = () => {
  
  const activeTab = sessionStorage.getItem("eRecuperadorActiveTabCompany") || "2";
  const [currentCnpj, setCurrentCnpj] = useState(null);
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany"))?.Cnpj;
  const [desabilitarOpcoesConfiguracao, setDesabilitarOpcoesConfiguracao] = useState(false);

  const verificarProcessamentoDosArquivos = async () => {
    const response = await getBloqueioCfopConfiguracao(cnpj);
    setDesabilitarOpcoesConfiguracao(response);
  };

  useEffect(() => {
    setCurrentCnpj(cnpj)
    verificarProcessamentoDosArquivos()
  }, [cnpj, activeTab])

  return (
    <Tabs className="ant-tabs-default" type="card">
      <TabPane tab="Dados cadastrais" key="1">
        <Data />
      </TabPane>
      <TabPane tab="cfop" key="2">
        <Cfop cnpj={currentCnpj} desabilitarOpcoesConfiguracao={desabilitarOpcoesConfiguracao} />
      </TabPane>
      <TabPane tab="Configurações" key="3">
        <Configuration desabilitarOpcoesConfiguracao={desabilitarOpcoesConfiguracao} />
      </TabPane>
    </Tabs>
  );
};

export default DataCompany;
